import {ConfigProvider} from 'antd';
import React from 'react';

const DropdownConfigProvider: React.FC<{children: React.ReactNode}> = ({
  children
}) => {
  const popupSources = [
    'ant-select',
    'ant-picker',
    'ant-dropdown',
    'ant-cascader'
  ];

  return (
    <ConfigProvider
      getPopupContainer={(triggerNode: any) => {
        if (triggerNode?.closest('.ant-tooltip-open')) {
          return undefined;
        }
        for (
          let el: HTMLElement | null = triggerNode;
          el;
          el = el?.parentElement
        ) {
          if (popupSources?.some((cls) => el?.classList?.contains(cls))) {
            return el?.parentElement ?? triggerNode;
          }
        }

        return triggerNode;
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default DropdownConfigProvider;
